import React from 'react';
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil';
import { getTermTextMappedWithLinks, replaceLinkTypesToHref, } from 'root/src/client/v2/drop/components/SponsorshipTerms/helpers';
import { LinkTermTypesEnum } from 'root/src/client/v2/drop/components/SponsorshipTerms/types';
import { PointsFAQLink } from 'root/src/client/v2/common/components/PointsFAQLink';
export function SponsorshipTerms({ terms, dropEvent, shortUrl, canEarnPoints, isTermsAccepted, canUserReclaimReservation = false, pointsReservationDueDate, streamDate, }) {
    const linkTypes = {
        [LinkTermTypesEnum.SHORT_LINK]: shortUrl,
    };
    return (<div className="flex flex-col mb-3 w-full items-center">
			{terms.map((term) => {
            const { visibilityCondition, text, links, color } = term;
            const isVisible = (typeof visibilityCondition !== 'undefined')
                ? visibilityCondition({
                    dropEvent,
                    canEarnPoints,
                    isTermsAccepted,
                    canUserReclaimReservation,
                    shortUrl,
                    streamDate,
                    pointsReservationDueDate,
                })
                : true;
            if (!isVisible) {
                return null;
            }
            const textMod = typeof text === 'function' ? text({ dropEvent, streamDate, pointsReservationDueDate, isTermsAccepted }) : text;
            const replacedLinkTypesByHref = replaceLinkTypesToHref(links !== null && links !== void 0 ? links : [], linkTypes);
            return (<SponsorshipTerm key={textMod} text={textMod} links={replacedLinkTypesByHref} color={color}/>);
        })}
			{canEarnPoints && <PointsFAQLink className="my-2"/>}
		</div>);
}
export function SponsorshipTerm({ text, links, color }) {
    return (<div className="flex items-center m-1 justify-center">
			<BulletTerm color={color}/>
			<TextTerm text={text} links={links}/>
		</div>);
}
function BulletTerm({ color }) {
    return (<div style={{ borderColor: color, backgroundColor: color }} className="flex m-3 p-0.5 border bg-clip-content rounded-full w-8 h-8 self-start"/>);
}
function TextTerm({ text, links }) {
    const mappedTextWithLinks = getTermTextMappedWithLinks(text, links);
    return (<span className="text-base w-[400px]">
			{mappedTextWithLinks.map(({ textPart, href }) => {
            if (!href) {
                return (<React.Fragment key={textPart}>{textPart}</React.Fragment>);
            }
            return (<a key={href} href={addHttpsProtocol(href)} target="blank" style={{ color: '#8ab4f8' }}>{href}</a>);
        })}
		</span>);
}
